module.exports = __webpack_public_path__ + "src/shared-components/icons/dropdown-arrow.885b113360cd8389bd2ceceb43a7eb53.svg";